module.exports = __webpack_public_path__ + "img/Logo_iNoe_180px.61e640c2.png";